<template>
  <div v-if="frame" class="quiz-tag" v-on:click.stop v-on:mouseleave.stop :style="[contentColors]" :class="listClasses">
    <div v-if="!submitted" class="quiz-tag-content">
      <!-- <div class="question-mark" :style="'color:' + this.colors[7]">
        <i class="material-icons" >
          help_outline
        </i>
      </div> -->
      <h1 class="question">
        {{question}}
      </h1>
      <div v-if="instruction" class="quiz-tag-instruction" :style="'color:' + this.colors[3]">
          {{ instruction }}
      </div>
      <ul v-sortable="{onEnd: reorder, disabled: !quiz.isSortable, handle: '.swap'}" :class="listClasses">
        <li v-for="(answer, key) in answers" v-bind:key="keyPart + key" :id="'answer' + key" class="answer _flxrscntr" :style="[boxColors, boxWidth]" :class="{'swap': quiz.isSortable, 'is-selected': values[key], 'answer-image': hasImage}" v-on:click="onCheck(key, !values[key])">
          <div v-if="quiz.isSortable" class="_flxrscntr _mrm">
            <div class="answer-index _mrm">{{ key + 1 }}.</div>
            <i v-if="alignment === 'h-layout'" class="material-icons">swap_horizontal_circle</i>
            <i v-else class="material-icons">swap_vertical_circle</i>
          </div>
          <div v-if="hasImage" class="quiz-answer-image-content _flxrscntr">
            <div class="quiz-answer-image-content image" v-if="hasImage && displayAnswerImage(answer.image)" :style="[imageBox, {'background' : 'url(' + displayAnswerImage(answer.image) + ') no-repeat center center'}]">
            </div>
            <div v-if="answer.text && answer.text[selectedLanguage]">
              <p v-for='(line, key) in answer.text[selectedLanguage].split("\n")' v-bind:key="key">{{line}}</p>
            </div>
          </div>
          <div v-if="!hasImage" class="quiz-answer-content _flxrscntr">
            <div v-if="answer.text && answer.text[selectedLanguage]">
              <p v-for='(line, key) in answer.text[selectedLanguage].split("\n")' v-bind:key="key">{{line}}</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="quiz-tag-submit">
        <button class="quiz-tag__button" :style="submitColors" @click="submit()">{{quiz.submitButtonText ? quiz.submitButtonText[selectedLanguage] : 'Submit'}}</button>
      </div>
      <div class="progress-display">
        <div class="count">
          {{ quizCounter }}
        </div>
        <svg class="progress" viewBox="0 0 120 120">
            <circle class="progress__meter" cx="60" cy="60" r="54" stroke-width="12" />
            <circle class="progress__value" :style="{ strokeDashoffset: dashOffset, strokeDasharray: circumFerence }" cx="60" cy="60" r="54" stroke-width="12" />
        </svg>
        <div v-if="skippable" class="navigate">
          <button v-if="hasMultiQuizzes || quizCount > 1" @click="navigate(-1)" title="Previous">
            <i class="material-icons">
              arrow_back
            </i>
          </button>
          <button @click="skip()" title="Skip">
            <i class="material-icons">
              skip_next
            </i>
          </button>
          <button v-if="hasMultiQuizzes || quizCount > 1" @click="navigate(1)" title="Next">
            <i class="material-icons">
              arrow_forward
            </i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="submitted && !isMaxTries" class="quiz-tag-content" style="justify-content: center;">
      <div :class="isCorrect ? 'wright-mark' : 'wrong-mark'">
        <i class="material-icons" >
          {{isCorrect ? 'done' : 'clear'}}
        </i>
      </div>
      <div :class="isCorrect ? 'quiz-tag-feedback _flxrscntr is-wright' : 'quiz-tag-feedback _flxrscntr is-wrong'" :style="[boxColors]">
        {{ feedback }}
      </div>
    </div>
    <div v-if="submitted && isMaxTries" class="quiz-tag-content" style="justify-content: center;">
      <div class="wrong-mark">
        <i class="material-icons" >
          clear
        </i>
      </div>
      <div class="quiz-tag-maxTriesfeedback _flxrscntr is-wrong" :style="[boxColors]">
        {{ quiz.maxTriesFeedback[selectedLanguage] }}
      </div>
    </div>
  </div>
</template>
<script>

import * as Sortable from 'sortablejs/Sortable.js'
import { evaluateQuizAnswerBoxStyles, evaluateQuizBoxStyles } from './utils.js'
import { whiteColor, blackColor } from "./utils";
import { base, quiz, hasImagesOnly } from './mixins/multilang'
import { analytics } from './mixins/analytics/'

export default {
  name: 'quizTag',
  mixins: [base, quiz, hasImagesOnly, analytics],
  props: ['meta', 'frame', 'isLastFrame', "dimensions", "selectedQuizIndex"],
   created() {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName('viewer-video')[0]
    })
    console.log('quizTag created', this.meta, this.dimensions)
    this.initTag()
  },
  data() {
    // const answers = this.meta.quiz.isSortable ? this.shuffle(this.meta.quiz.answers) : this.meta.quiz.answers
    // const values = new Array(this.meta.quiz.answers.length)
    return {
      submitted: false,
      feedback: '',
      values: [],
      answers: [],
      isCorrect: false,
      videoElement: null,
      hasImage: false,
      alignment: null,
      isMaxTries: false,
      keyPart: new Date().toTimeString(),
      dashOffset: 0,
    }
  },
  watch: {
    isLastFrame(value) {
      if (value && !this.isMaxTries) {
        this.$emit('show')
        this.videoElement.pause()
      }
    },
    'quiz': 'initTag'
  },
  computed: {
    listClasses: function() {
      const classes = []
      classes.push(this.alignment)
      classes.push(this.hasImagesOnly ? 'images-only' : '')
      return classes
    },
    quizCounter: function() {
      if (this.hasMultiQuizzes) {
          let index = this.quizIndex + 1
          this.quizProgress((index/this.meta.quizzes.length)*100)
          return `${index} / ${this.meta.quizzes.length}`
      } else {
        const _this = this     
        this.quizIndex = 0
        this.quizCount = 0
        if (this.$parent.tag && this.$parent.$parent.tags) {
          const quizId = this.$parent.tag.id
          const quizTags = []
          this.$parent.$parent.tags.map((tag) => {
            if (tag.template === "quiz") {
              quizTags.push(tag)
            }
          })

          this.sortedTags = quizTags.sort((a, b) => {
            if (a.scenes && a.scenes[0] && b.scenes && b.scenes[0]) {
              return a.scenes[0].waypoints[0].time - b.scenes[0].waypoints[0].time
            }
          })
          this.sortedTags.map((tag) => {
            _this.quizCount++
            if (tag.id === quizId) {
              _this.quizIndex = _this.quizCount
            }
          })
          this.quizProgress((this.quizIndex/this.quizCount)*100)
          return `${this.quizIndex} / ${this.quizCount}`
        }
      }
      return ''
    },
    imageBox: function() {
      // version to kick off update from forceUpdate
      var v = this.version
      if (this.hasImage || this.alignment === 'h-layout') {
        // square image
        let so = {"height": `${this.dimensions.w / 7 - 20}px !important`};
        return so
      }
    },
    boxWidth: function() {
             // version to kick off update from forceUpdate
      var v = this.version
      if (this.hasImage || this.alignment === 'h-layout') {
        //Todo: Maybe there is a better wy to calculate the vw
        // return {"width": `${22 - Math.ceil(this.meta.quiz.answers.length * (1 + this.meta.quiz.answers.length / 7))}vw !important`};
        // do not use vw or vh, as when embededded this does not conform to the size of the embedded iFrame
        const width = this.dimensions.w / Math.ceil(this.meta.quiz.answers.length * (1 + this.meta.quiz.answers.length / 9))
        let so = {"width": `${width < 400 ? width : 400}px !important`};
        return so
      }
    },
    boxColors: function() {
             // version to kick off update from forceUpdate
      var v = this.version
       return {
        "color": this.colors[1] || blackColor,
        "background-color": this.colors[2] || whiteColor
      };
    },
    contentColors: function() {
             // version to kick off update from forceUpdate
      var v = this.version
       return {
        "color": this.colors[0] || blackColor,
        "background-color": this.colors[4] || whiteColor
      };
    },
    submitColors: function() {
      // version to kick off update from forceUpdate
      var v = this.version
       return {
        "color": this.colors[5] || blackColor,
        "background-color": this.colors[6] || whiteColor
      };
    },
    quiz: function() {
             // version to kick off update from forceUpdate
      var v = this.version
      return this.meta.quiz
    }
  },
  directives: {
    sortable: {
      inserted(el, binding) {
        Sortable.create(el, binding.value)
      }
    }
  },
  methods: {
    initTag() {
      this.meta.quiz.isSortable = this.meta.quiz.type ? this.meta.quiz.type === 'sortable' : this.meta.quiz.isSortable
      this.options = this.answers = this.meta.quiz.isSortable ? this.shuffle(this.meta.quiz.answers) : this.meta.quiz.answers
      this.colors = this.meta.quiz.colorScheme ? this.meta.quiz.colorScheme.colors : []
      this.hasMultiQuizzes = this.meta.quizzes && this.meta.quizzes.length > 0        

      for (var i = 0; i < this.meta.quiz.answers.length; i++) {
        this.values[i] = false
      }
      this.isCorrect = this.meta.quiz.isSortable ? this.isCorrectOrder(this.answers, this.meta.quiz.answers) : this.isCorrectValues(this.meta.quiz.answers, this.values)
      this.alignment = this.meta.quiz.alignement || 'v-layout'
      this.quiz.tries = 0
      this.hasImage = this.meta.quiz.hasImage === undefined || this.meta.quiz.hasImage
      this.circumFerence = 2 * Math.PI * 54
      this.quizCount = 0
      this.quizIndex = this.selectedQuizIndex || 0
      this.sortedTags = []
      this.skippable = this.meta.quiz.skippable !== undefined ? this.meta.quiz.skippable : true,
      console.log('quizTag.inited', this.$vnode.tag, this.answers, this.values)
    },
    quizProgress: function(value) {
      const progressValue = document.querySelector('.progress__value');
      const progress = value / 100;
      this.dashOffset = this.circumFerence * (1 - progress);
    },
    onCheck(i, value) {
      const liCssClass = this.hasImage ? 'answer _flxrscntr answer-image' : 'answer _flxrscntr'
      console.log(this.$vnode.tag + ': onCheck selected', i, this.values)
      if (!this.quiz.isSortable) {
        if (this.quiz.type === 'singleChoice') {
          for (let index = 0; index < this.meta.quiz.answers.length; index++) {
            if (index === i) {
              this.values[index] = true
              this.$el.querySelector("#answer" + index).setAttribute("class", `${liCssClass} is-selected`)
            } else {
              this.values[index] = false
              this.$el.querySelector("#answer" + index).setAttribute("class", `${liCssClass}`)
            }
          }
        } else {
          this.values[i] = value
          this.$el.querySelector("#answer" + i).setAttribute("class", value ? `${liCssClass} is-selected` : `${liCssClass}`)
        }
      }
      this.isCorrect = this.isCorrectValues(this.meta.quiz.answers, this.values)
    },
    onClick(i) {
      // this.onCheck(i, !this.values[i])
      this.values[i] = true
      console.log(this.values[i])
      this.$el.querySelector("#quiz_answer_" + i).checked = true
    },
    navigate(direction) {
      if (this.hasMultiQuizzes) {
        this.$emit('navigate', direction)
      } else {
        const quizId = this.$parent.tag.id
        let quizCount = 0
        let quizIndex = 0
        this.sortedTags.map((tag) => {
            if (tag.id === quizId) {
              quizIndex = quizCount
            }
            quizCount++
        })
        const nextQuizIndex = quizIndex + direction
        let nextTag = null
        if (direction > 0) {
          nextTag = this.sortedTags[nextQuizIndex < this.sortedTags.length ? nextQuizIndex : 0]
        } else {
          nextTag = this.sortedTags[nextQuizIndex >= 0 ? nextQuizIndex : this.sortedTags.length - 1]
        }

        this.videoElement.currentTime = nextTag.scenes[0].waypoints[0].time - 0.025
        this.videoElement.play()
      }
    },
    skip() {
      if (this.hasMultiQuizzes) {
        this.$emit('submit')
      } else {
        this.videoElement.currentTime = this.videoElement.currentTime + 0.001
        this.videoElement.play()
      }
    },
    submit() {
      console.log('submit')
      this.isCorrect = this.meta.quiz.isSortable ? this.isCorrectOrder(this.answers, this.meta.quiz.answers) : this.isCorrectValues(this.meta.quiz.answers, this.values)
      this.meta.quiz.isCorrectAnswered = this.isCorrect
      this.submitted = true
      // see mixins for fields
      this.feedback = this.isCorrect ? this.correctFeedback : this.wrongFeedback
      this.quiz.tries = this.isCorrect ? 0 : this.quiz.tries += 1
      this.isMaxTries = this.quiz.tries >= this.quiz.maxTries && this.quiz.maxTries !== '' && this.quiz.maxTries !== undefined && this.quiz.maxTries > 0
      
      // analytics
      let options = this.answers.filter((a, index) => {
        // checked or not
        if (this.values[index]) {
          return true
        }
        return false
      })
      this.trackQuizTag("Quiz", options, this.isCorrect ? 1 : 0)

      setTimeout(() => {
        // reset submitted for now, for repeated use
        this.submitted = false
        if (this.isMaxTries) {
          this.$emit("action", this.quiz.behaviour.value);
        } else if (!this.hasMultiQuizzes) {
          const targetTime = this.isCorrect ? this.meta.quiz.correctTarget : this.meta.quiz.incorrectTarget
          if (targetTime) {
            this.videoElement.currentTime = targetTime
          }
          this.videoElement.play()
        }

        if (this.hasMultiQuizzes) {
          this.$emit("submit")
        } else {
          this.$emit('hide')
        }
      }, this.meta.quiz.feedbackTime * 1000 || 3000)
    },
    shuffle(arr) {
      const array = [...arr]
      let m = array.length
      let t
      let i
      while (m) {
        i = Math.floor(Math.random() * m--)
        t = array[m]
        array[m] = array[i]
        array[i] = t
      }

      return array
    },
    reorder({ oldIndex, newIndex }) {
      const movedItem = this.answers.splice(oldIndex, 1)[0]
      this.answers.splice(newIndex, 0, movedItem)
      this.keyPart = new Date().toTimeString()
      this.isCorrect = this.isCorrectOrder(this.answers, this.meta.quiz.answers)
    },
    isCorrectValues(answers, values) {
      for (let i = 0; i < values.length; i++) {
        if (!!answers[i].correct !== !!values[i]) {
          return false
        }
      }
      return true
    },
    isCorrectOrder(answers, truth) {
      for (let i = 0; i < answers.length; i++) {
        if (answers[i] !== truth[i]) {
          return false
        }
      }
      return true
    },
    displayAnswerImage(image) {
      let imageSrc = null
      if (typeof image === 'string') {
        imageSrc = image
      } else if (image) {
        imageSrc = this.getTextFromMultiLang(image, this.selectedLanguage || image.lang, this.version)
      }
      return imageSrc && imageSrc !== '' ? imageSrc : null
    },
     /* forceUpdate is here for the preview Tag in order to kick off an update of the visuals */
    forceUpdate(meta) {
      console.log("forceUpdate", this.version)
      // init meta based props
      this.initTag()
      // inc version that will kick of computed
      this.version = this.version + 1
      this.selectedLanguage = this.meta.quiz.question.lang
    }
  }
}

</script>
